export function AdamSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/adam.svg'"></ng-include>`
    }
}